import { userTypes } from "./user.types";

export const setUserChannels = (userChannels) => ({
  type: userTypes.SET_USER_CHANNELS,
  payload: userChannels,
});

export const loadAgent = (payload) => ({
  type: userTypes.LOAD_AGENT,
  payload,
});

export const setAgentInfo = (agentInfo) => ({
  type: userTypes.SET_AGENT_INFO,
  payload: agentInfo,
});

export const setAgents = (agents) => ({
  type: userTypes.SET_AGENTS,
  payload: agents,
});

export const setContainerInfo = (containerInfo) => ({
  type: userTypes.SET_CONTAINER_INFO,
  payload: containerInfo,
});

export const setConversationCharge = (count) => ({
  type: userTypes.SET_CONVERSATIONS_CHARGE,
  payload: count,
});

// POST REQUEST FOR TWO-STEP VERIFICATION
export const postUserDataForOTV = (data) => ({
  type: userTypes.POST_USER_DATA_OF_OTP,
  payload: data,
});

export const postUserDataForOTVSuccess = (data) => ({
  type: userTypes.POST_USER_DATA_OF_OTP_SUCCESS,
  payload: data,
});

export const postUserDataForOTVFailure = (error) => ({
  type: userTypes.POST_USER_DATA_OF_OTP_FAILURE,
  payload: error,
});

export const loginUserWithOneTimeVerification = (payload) => ({
  type: userTypes.LOGIN_USER_ONE_TIME_VERIFICATION,
  payload,
});
